import { render, staticRenderFns } from "./DragableList.vue?vue&type=template&id=0db1754b&scoped=true"
import script from "./DragableList.vue?vue&type=script&lang=ts"
export * from "./DragableList.vue?vue&type=script&lang=ts"
import style0 from "./DragableList.vue?vue&type=style&index=0&id=0db1754b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db1754b",
  null
  
)

export default component.exports